import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Typography,
  MenuItem,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import { api, get, post, put } from "../../../../../utils/api";
import { capitalizeFirstLetter } from "../../../../../utils/common";
import FileField from "../../../../../Components/Masters/FileField";
import { useUser } from "../../../../../context/AuthContext";
import EditDialog from "../../../../../Components/Common/EditDialog";
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: "55%",
      overflowY: "auto",
    },
  },
};
function AddIndustrialProcess(props) {
  const { user } = useUser();
  const [alreadyFacility, setAlreadyFacility] = useState(false);
  const [facilities, setFacilities] = useState(["Select"]); // Store list of facilities
  const [errors, setErrors] = useState({});
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});

  const initialState = {
    facility: "",
    location: "",
    industryProcess: "",
    finalManufacturedProduct: "",
    remark: "",
    documents: [],
  };
  const [fromValue, setFromValue] = useState(initialState);
  const [editDialog, setEditDialog] = useState(false);
  const [formData2, setFormData2] = useState([]);
  useEffect(() => {
    fetchFacilities();
    const state = {
      facility: props.selectedFacility?.facility?._id || "",
      location: props.selectedFacility?.location || "",
      industryProcess: props.selectedFacility?.industryProcess || "",
      finalManufacturedProduct:
        props.selectedFacility?.finalManufacturedProduct || "",
      remark: props.selectedFacility?.remark || "",
      // documents: props.selectedFacility?.documents || [],
    };
    setFromValue(state);
    setFormData2(state);
    setUploadedFiles(props.selectedFacility?.documents ?? []);

    setAlreadyFacility(props.selectedFacility === null ? false : true);
  }, [props.selectedFacility]);

  const handleClose = () => {
    const isFormDataUnchanged = Object.keys(fromValue).every(
      (key) => fromValue[key] === formData2[key]
    );
    const isFilesUnchanged =
      JSON.stringify(uploadedFiles) ===
      JSON.stringify(formData2?.documents || []);
    if (isFormDataUnchanged && isFilesUnchanged) {
      handleExitAgree();
    } else {
      setEditDialog(true);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Update form values
    setFromValue({
      ...fromValue,
      [name]: value,
    });

    // Clear the error for the specific field if there was one
    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "", // Clear the specific field error
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    const {
      location,
      industryProcess,
      finalManufacturedProduct,
      facility, // Add facility to validation
    } = fromValue;

    // Validate `Location`
    if (!location || location.trim() === "") {
      newErrors.location = "Location is required.";
    }

    // Validate `address`
    if (!industryProcess || industryProcess.trim() === "") {
      newErrors.industryProcess = "Industry process is required.";
    }

    // Validate `finalManufacturedProduct`
    if (!finalManufacturedProduct || finalManufacturedProduct.trim() === "") {
      newErrors.finalManufacturedProduct =
        "Final Manufacture Product is required.";
    }

    // Validate `Facility`
    if (user?.companyAdmin === true && !fromValue.facility) {
      newErrors.facility = "Facility is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  console.log("error", errors);

  // Fetch facilities data from API
  const fetchFacilities = async () => {
    try {
      const response = await get("/master/getAllFacility");
      setFacilities(response.data.data);
    } catch (error) {
      console.log("Error fetching facilities:", error);
    }
  };

  const getDropDownFieldId = (data) => {
    if (typeof data === "string") {
      return data; // If it's a direct ID, return it
    }
    return data?._id || ""; // If it's an object, return the _id
  };

  const Save = async () => {
    if (!validateForm()) {
      return;
    }
    try {
      const dataToSend = {
        ...fromValue,
        documents: uploadedFiles,
        location: capitalizeFirstLetter(fromValue.location),
        finalManufacturedProduct: capitalizeFirstLetter(
          fromValue.finalManufacturedProduct
        ),
        industryProcess: capitalizeFirstLetter(fromValue.industryProcess),
      };

      const url = alreadyFacility
        ? `${api}/master/updateIndustrialProcess?Id=${props.selectedFacility?._id}`
        : `${api}/master/addIndustrialProcess`;

      const response = alreadyFacility
        ? await put(url, dataToSend)
        : await post(url, dataToSend);

      handleExitAgree();
      props.setAddFacility(false);
      props.setsnackOpen({
        open: true,
        message: response.data.message,
        severity: "success",
      });
      props.fetchFacilities();
    } catch (err) {
      if (err?.response?.data?.message) {
        let errorKey = err?.response?.data?.errorKey;
        setErrors((prevErrors) => ({
          ...prevErrors,
          [errorKey]: err?.response?.data?.message,
        }));
      }
      // const errorMessage = err?.response?.data?.message || "An error occurred";
      // setErrors((prevErrors) => ({
      //   ...prevErrors,
      //   industryProcess: errorMessage,
      // }));
    }
  };

  const handleExitAgree = () => {
    setFromValue(
      props.selectedFacility === null ? initialState : props.selectedFacility
    );
    setFormData2(
      props.selectedFacility === null ? initialState : props.selectedFacility
    );

    props.setAddFacility(false);
    props.fetchFacilities();
    setErrors({}); // Clear any existing errors
    setAlreadyFacility(false); // Reset alreadyFacility state
    setUploadedFiles([]);
    setEditDialog(false);
  };

  const handleDropdownChange = (e) => {
    const { name, value } = e.target;
    setFromValue((prevFromValue) => ({
      ...prevFromValue,
      facility: name === "facility" ? value : prevFromValue.facility,
    }));
  };

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.5rem",
        maxWidth: "100%",
        height: "100vh",
      }}
    >
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          onClick={() => {
            handleClose();
          }}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box sx={{ width: "90%", p: 3, backgroundColor: "#fff", height: "100vh",
          overflowY: "scroll", }}>
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",
            mb: 2,
          }}
        >
          {props.selectedFacility?._id === undefined
            ? "Add Industrial Process"
            : "Edit Industrial Process"}
        </Typography>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
          Location
        </Typography>
        <CustomTextField
          variant="outlined"
          fullWidth
          name="location"
          value={fromValue.location}
          onChange={handleChange}
          placeholder="Location"
          error={!!errors.location} // Show error styling if there's an error
          InputLabelProps={{
            style: { color: errors.location ? "#D34040" : undefined },
          }}
        />
        {errors.location && (
          <Typography variant="body2" color="#D34040">
            {errors.location}
          </Typography>
        )}

        {user?.companyAdmin && (
          <>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
              Facility
            </Typography>
            <CustomTextField
              select
              variant="outlined"
              value={fromValue.facility || "Tap to Select"}
              onChange={handleDropdownChange}
              fullWidth
              name="facility"
              placeholder="Tap to Select"
              error={!!errors.facility}
              InputLabelProps={{
                style: { color: errors.facility ? "#D34040" : undefined },
              }}
            >
              <MenuItem value="Tap to Select" disabled>
                Tap to Select
              </MenuItem>
              {facilities.map((item, i) => (
                <MenuItem key={i} value={item?._id}>
                  {item.facilityName}
                </MenuItem>
              ))}
            </CustomTextField>

            {errors.facility && (
              <Typography variant="body2" color="#D34040">
                {errors.facility}
              </Typography>
            )}
          </>
        )}

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Industry Process
        </Typography>
        <TextField
          multiline
          rows={3}
          variant="outlined"
          fullWidth
          name="industryProcess"
          value={fromValue.industryProcess}
          onChange={handleChange}
          placeholder="Industry Process"
          error={!!errors.industryProcess} // Show error styling if there's an error
          InputLabelProps={{
            style: { color: errors.industryProcess ? "#D34040" : undefined },
          }}
        />
        {errors.industryProcess && (
          <Typography variant="body2" color="#D34040">
            {errors.industryProcess}
          </Typography>
        )}
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Final Manufactured Product
        </Typography>
        <TextField
          multiline
          rows={3}
          variant="outlined"
          fullWidth
          name="finalManufacturedProduct"
          value={fromValue.finalManufacturedProduct}
          onChange={handleChange}
          placeholder="Final Manufactured Product"
          error={!!errors.finalManufacturedProduct} // Show error styling if there's an error
          InputLabelProps={{
            style: {
              color: errors.finalManufacturedProduct ? "#D34040" : undefined,
            },
          }}
        />
        {errors.finalManufacturedProduct && (
          <Typography variant="body2" color="#D34040">
            {errors.finalManufacturedProduct}
          </Typography>
        )}
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Remark
        </Typography>
        <TextField
          multiline
          rows={2}
          variant="outlined"
          fullWidth
          name="remark"
          value={fromValue.remark}
          onChange={handleChange}
          placeholder="Remark"
        />

        <FileField
          title={"Upload Documents"}
          name={"documents"}
          errors={errors["documents"]}
          fileUrls={uploadedFiles}
          progress={uploadProgress["documents"] || []}
          {...{ setUploadedFiles, setUploadProgress, setErrors }}
          // onDelete={handleDeleteFile}
        />
        {errors.documents ? (
          <Typography variant="body2" color="#D34040">
            {/* {errors.documents} */}
          </Typography>
        ) : (
          ""
        )}

        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <div>
      <Drawer
        // sx={{
        //   backgroundColor: "transparent",
        //   "& .MuiDrawer-paper": {
        //     // This targets the paper component within the Drawer
        //     backgroundColor: "transparent", // Make paper transparent
        //     boxShadow: "none", // Optional: Remove any shadow
        //   },
        // }}
         sx={{
        backgroundColor: "transparent",
        height: "100vh",
        minHeight: "100vh",
        overflowY: "auto",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100vh",
          minHeight: "100vh",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
        anchor="right"
        open={props.addFacility}
        onClose={() => {
          handleClose();
        }}
      >
        {list()}
      </Drawer>
    </div>
  );
}

export default AddIndustrialProcess;

//// custom textfield

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px", // Adjust height as needed
  },
  "& .MuiSelect-select": {
    height: "56px", // Adjust height as needed
    display: "flex",
    alignItems: "center",
  },
}));
